import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../theme";
import { formatKey, formatValue } from "../../../utils/utils";

const UserProfileDetails = ({ details }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <div className="row g-3">
      {Object.entries(details).map(([key, value]) => {
        if (["answers", "personalities", "photos"].includes(key)) return null;

        const formattedValue = formatValue(key, value);
        let displayValue =
          typeof formattedValue === "string"
            ? formattedValue.split(",").join(", ")
            : formattedValue ?? "N/A";
            
        // Special case for Gender
        if (formatKey(key).trim() === "Gender") {
          if (displayValue.toLowerCase() === "women") {
            displayValue = "Woman";
          } else if (displayValue.toLowerCase() === "men") {
            displayValue = "Man";
          }
        }

        return (
          <div className="col-12 col-lg-6 mb-3" key={key}>
            <h6 style={{ color: colors.primary[700] }}>{formatKey(key)}</h6>
            <input
              type="text"
              className="form-control"
              value={displayValue}
              readOnly
            />
          </div>
        );
      })}
    </div>
  );
};

export default UserProfileDetails;
